import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export const Footer = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].footer;
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <footer className="w-full bg-white pt-20" data-id="element-107">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col items-center" data-id="element-108">
          <h2 className="font-serif-display text-4xl md:text-5xl uppercase tracking-widest text-[#1a1a1a] mb-4" data-id="element-109">
            Cenia Badillo
          </h2>
          <span className="uppercase tracking-widest text-xs font-medium text-[#c9a96e] mb-12" data-id="element-110">
            {t.brokerage}
          </span>

          <div className="w-full h-px bg-[#c9a96e]/30 mb-16" data-id="element-111" />

          <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left mb-16" data-id="element-112">
            {/* Quick Links */}
            <div className="flex flex-col items-center md:items-start" data-id="element-113">
              <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-6" data-id="element-114">
                {t.quickLinks}
              </h4>
              <div className="flex flex-col space-y-4" data-id="element-115">
                {['properties', 'about', 'services', 'neighborhoods'].map(item => <button key={item} onClick={() => scrollToSection(item)} className="text-sm text-[#1a1a1a] hover:text-[#c9a96e] transition-colors uppercase tracking-wider" data-id="element-116">
                      {translations[lang].nav[item as keyof (typeof translations)['en']['nav']]}
                    </button>)}
              </div>
            </div>

            {/* Contact */}
            <div className="flex flex-col items-center md:items-start" data-id="element-117">
              <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-6" data-id="element-118">
                {t.contact}
              </h4>
              <div className="flex flex-col space-y-4 text-sm text-[#1a1a1a]" data-id="element-119">
                <a href="tel:6513872889" className="hover:text-[#c9a96e] transition-colors" data-id="element-120">
                  651.387.2889
                </a>
                <a href="mailto:contact@ceniabadillo.com" className="hover:text-[#c9a96e] transition-colors" data-id="element-121">
                  contact@ceniabadillo.com
                </a>
                <p className="text-[#1a1a1a]/70" data-id="element-122">
                  Coldwell Banker Realty
                  <br data-id="element-123" />
                  Minnesota
                </p>
              </div>
            </div>

            {/* Legal / Social */}
            <div className="flex flex-col items-center md:items-start" data-id="element-124">
              <h4 className="uppercase tracking-widest text-xs font-medium text-[#1a1a1a]/50 mb-6" data-id="element-125">
                Legal
              </h4>
              <div className="flex flex-col space-y-4" data-id="element-126">
                <button onClick={() => setModalContent('privacy')} className="text-sm text-[#1a1a1a] hover:text-[#c9a96e] transition-colors uppercase tracking-wider" data-id="element-127">
                  {t.privacy}
                </button>
                <button onClick={() => setModalContent('terms')} className="text-sm text-[#1a1a1a] hover:text-[#c9a96e] transition-colors uppercase tracking-wider" data-id="element-128">
                  {t.terms}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="w-full bg-[#1a1a1a] py-6" data-id="element-129">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-130">
            <p className="text-white/50 text-xs tracking-wider" data-id="element-131">{t.rights}</p>

            <div className="flex items-center space-x-6" data-id="element-132">
              <span className="text-white/50 text-xs border border-white/20 px-2 py-1 rounded-sm" title="Equal Housing Opportunity" data-id="element-133">
                EHO
              </span>
              <span className="text-white/50 text-xs border border-white/20 px-2 py-1 rounded-sm" title="Multiple Listing Service" data-id="element-134">
                MLS
              </span>
            </div>

            <a href="tel:6513872889" className="text-[#c9a96e] text-sm tracking-widest hover:text-white transition-colors" data-id="element-135">
              651.387.2889
            </a>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <AnimatePresence data-id="element-136">
        {modalContent && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setModalContent(null)} data-id="element-137">
            <motion.div initial={{
          y: 50,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 50,
          opacity: 0
        }} onClick={e => e.stopPropagation()} className="bg-white w-full max-w-2xl max-h-[80vh] overflow-y-auto p-8 lg:p-12 relative" data-id="element-138">
              <button onClick={() => setModalContent(null)} className="absolute top-6 right-6 text-[#1a1a1a]/50 hover:text-[#1a1a1a] transition-colors" data-id="element-139">
                <X size={24} strokeWidth={1.5} data-id="element-140" />
              </button>

              <h3 className="font-serif-display text-3xl mb-6 text-[#1a1a1a]" data-id="element-141">
                {modalContent === 'privacy' ? t.privacy : t.terms}
              </h3>

              <div className="body-text text-sm text-[#1a1a1a]/80 space-y-4" data-id="element-142">
                <p data-id="element-143">
                  This is a placeholder for the{' '}
                  {modalContent === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}{' '}
                  content. In a production environment, this would contain the
                  full legal text required for real estate compliance.
                </p>
                <p data-id="element-144">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p data-id="element-145">
                  Duis aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum.
                </p>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};